/**
 * 哪些路由是"沉浸式工作区"——进去之后不显示全局导航栏。
 *
 * 画布编辑器自己左侧就有一条工具条，再叠一条全局导航等于两条竖栏并排，
 * 既挤画布又让人分不清哪条是干什么的。而且进到具体某张画布里，用户的
 * 任务是把这张画布做完，不是切模块。回首页的入口在画布左上角的 xy ▾
 * 菜单里（「返回创作首页」/「全部画布」）。
 *
 * 写作台同理：它自己左侧有章节栏、右侧有 Agent 面板，中间是正文，
 * 再叠一条全局导航就是三条竖栏。进到某个项目里，用户的任务是把这一集写完。
 * 回上层的入口在左上角「故事库 ▾」，和画布的 xy ▾ 是同一套设计。
 *
 * ⚠️ 只匹配具体某张画布 / 某个写作项目：/canvas 与 /writing 列表页仍然
 * 保留导航栏——用户在列表页就是在挑东西，那里正需要能切模块。
 *
 * 单独成文件而不是放在 VNextLayout 里，是为了让它能被直接测试：
 * VNextLayout 依赖 react-router-dom，而 CRA 的 jest 解析不了那个包的
 * exports 字段，测它必须先 mock 整个 router，纯函数不该背这个负担。
 */
const IMMERSIVE_ROUTES = [
  /^\/canvas\/[^/]+\/?$/,
  /^\/prototype\/vnext\/canvas\/[^/]+\/?$/,
  /^\/writing\/[^/]+\/?$/,
  /^\/prototype\/vnext\/writing\/[^/]+\/?$/,
  /^\/prototype\/vnext\/learn\/cases\/[^/]+(?:\/workflow)?\/?$/,
];

export function isImmersiveRoute(pathname) {
  return IMMERSIVE_ROUTES.some((pattern) => pattern.test(pathname || ''));
}
